import axios from 'axios';
let API_URL = '';
export class ClientsAPI {

    constructor(baseURL) {
        API_URL = baseURL;
    }

    GetClients(status, subProgramID, caseManagerID, additionalRecords) {
        const url = API_URL + '/API/Foster/FosterClients/GetClients';
        return axios.post(
            url,
            {
                Status: status,
                SubProgramID: subProgramID,
                CaseManagerID: caseManagerID,
                AdditionalRecords: additionalRecords
            }
            )
            .then(response => response.data);
    }

}